import { map } from './map';
import { transform } from './transform';

export const floor = transform(map, Math.floor);
